import { put, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { clearFields } from 'redux-form';
import {
  getShowSeasonByShowId,
  submitApplicants,
  getShowSeasonByShowIdAndActivelyCasting
} from '../../api/showSeasonAPI';
import * as types from './showSeasonActionTypes';

const getFormStructure = state => state.formStructure.form;
const getShowSeasonIds = state => ({
  showId: state.show.show.sfId,
  showSeasonId: state.showSeason.season.sfId,
});
const getCountry = state => ({
  country: state.country.selected,
});

const updateMember = (member, formStructure) => {
  const finalMember = {
    photoUrl: member.photoUrl,
    photoId: member.photoUrlId,
    photoFormat: member.photoUrlFormat,
    videoUrl: member.videoUrl,
    videoId: member.videoUrlId,
    videoFormat: member.videoUrlFormat,
    fields: [],
  };
  delete member.photoUrl;
  delete member.photoUrlId;
  delete member.photoUrlFormat;
  delete member.videoUrl;
  delete member.videoUrlId;
  delete member.videoUrlFormat;
  finalMember.fields = Object.entries(member).map(([key, value]) => {
    const fieldDB = { ...formStructure.find(item => item.sfId === key) };
    fieldDB.value = value;
    return fieldDB;
  });
  return finalMember;
};

function* clearFormFields(applicants) {
  for (let i = 0; i < applicants.members.length; i++) {
    yield put(
      clearFields(
        `member${i + 1}`,
        false,
        false,
        ...[...Object.keys(applicants.members[i]), 'photoName', 'videoName']
      )
    );
  }
  for (let i = 0; i < applicants.team.length; i++) {
    yield put(
      clearFields(
        'team',
        false,
        false,
        ...[...Object.keys(applicants.team[i]), 'photoName', 'videoName']
      )
    );
  }
}

export function* showSeasonSaga() {
  try {
    const season = yield getShowSeasonByShowIdAndActivelyCasting();
    if (season && season.error) {
      yield put({
        type: types.GET_SHOW_SEASON_ERROR,
        error: season.error,
      });
    } else {
      if (season && season.length > 0) {
        yield put({
          type: types.GET_SHOW_SEASON_SUCCESS,
          season: season[0],
        });
      } else {
        try {
          const season = yield getShowSeasonByShowId();
          if (season && season.error) {
            yield put({
              type: types.GET_SHOW_SEASON_ERROR,
              error: season.error,
            });
          } else {
            yield put({
              type: types.GET_SHOW_SEASON_SUCCESS,
              season: season[0],
            });
          }
        } catch (error) {
          yield put({
            type: types.GET_SHOW_SEASON_ERROR,
            error,
          });
        }
      }
    }
  } catch (error) {
    yield put({
      type: types.GET_SHOW_SEASON_ERROR,
      error,
    });
  }
}

export function* submitApplicantsSaga({ applicants }) {
  try {
    const formStructure = yield select(getFormStructure);
    const showSeasonIds = yield select(getShowSeasonIds);
    const country = yield select(getCountry);
    const members = applicants.members.map(member =>
      updateMember(member, formStructure)
    );
    const team =
      applicants.members.length > 1
        ? updateMember(applicants.team[0], formStructure)
        : null;

    const response = yield submitApplicants({
      ...showSeasonIds,
      members,
      team,
      ...country,
    });

    if (response && response.error) {
      yield put({
        type: types.SUBMIT_APPLICANTS_ERROR,
        error: response.error,
      });
    } else {
      yield put({
        type: types.SUBMIT_APPLICANTS_SUCCESS,
        response,
      });
      yield put(push('/applySuccess'));
      yield clearFormFields(applicants);
    }
  } catch (error) {
    yield put({
      type: types.SUBMIT_APPLICANTS_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/showSeason/showSeasonSaga.js